// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ppgsnunaeoujsinykwlt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBwZ3NudW5hZW91anNpbnlrd2x0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY1Mjg5NTYsImV4cCI6MjA1MjEwNDk1Nn0.wND9PX_dAveU25n77mo-tu4Rl_t71dwfRSmL1aTgGEs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);